import React from 'react';
import { Box, Container, Snackbar, Alert, Typography } from '@mui/material';
import useMarketplaceSubscriptions, { Subscription } from '../hooks/useMarketplaceSubscriptions';
import MarketplaceSubscriptionCard from './MarketplaceSubscriptionCard';
import MarketplaceSubscriptionsEmptyState from './MarketplaceSubscriptionsEmptyState';
import Loading from '../../common/components/Loading';
import Config from '../../api/config';
import TertiaryButton from '../../common/components/TertiaryButton';

export default function MarketplaceSubscriptions() {
    const {
        loading,
        subscriptions,
        error,
        hasSubscriptions,
        clearError,
        setError,
        fetchSubscriptions,
    } = useMarketplaceSubscriptions();

    if (loading) {
        return <Loading />;
    }

    if (!hasSubscriptions) {
        return (
            <>
                <MarketplaceSubscriptionsEmptyState />
                <Snackbar
                    open={!!error}
                    autoHideDuration={6000}
                    onClose={clearError}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                >
                    <Alert severity="error" onClose={clearError} variant="filled">
                        {error}
                    </Alert>
                </Snackbar>
            </>
        );
    }

    return (
        <Box className="outer-container with-nav">
            <Container maxWidth="md">
                <Box display="flex" marginTop={6} marginBottom={2} justifyContent="space-between" alignItems="center">
                    <Typography variant="h1">Marketplace Subscriptions</Typography>
                    <TertiaryButton
                        onClick={() => { window.location.href = Config.URL_MARKETPLACE; }}
                    >
                        Find more teams on our Marketplace
                    </TertiaryButton>
                </Box>
                {subscriptions.map((subscription: Subscription) => (
                    <MarketplaceSubscriptionCard
                        key={subscription.id}
                        subscription={subscription}
                        onCancelled={fetchSubscriptions}
                        onError={setError}
                    />
                ))}
                <Snackbar
                    open={!!error}
                    autoHideDuration={6000}
                    onClose={clearError}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                >
                    <Alert severity="error" onClose={clearError} variant="filled">
                        {error}
                    </Alert>
                </Snackbar>
            </Container>
        </Box>
    );
}
